import { Navigate, Outlet, useLocation } from 'react-router-dom';

import LoaderOverlay from 'components/PageLayout/LoaderOverlay';
import { CuroAppRoute } from 'enums/curo/CuroAppRoute';
import { SessionStatus, useGetSessionStatus } from 'hooks/useGetSessionStatus';


const RedirectHandler = () => {
  const location = useLocation();
  const sessionStatus = useGetSessionStatus();

  const shouldRedirectToResumeProcess =
    sessionStatus === SessionStatus.Verified && location.pathname === CuroAppRoute.SignIn;

  if (sessionStatus === SessionStatus.Loading) {
    return <LoaderOverlay />;
  }

  if (shouldRedirectToResumeProcess) {
    return <Navigate to={CuroAppRoute.ResumeProcess} />;
  }

  return <Outlet />;
};

export default RedirectHandler;
